import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './views/Home.vue';
import Register from './views/auth/Register';
import SetPassword from './views/auth/SetPassword';
import ChangePassword from './views/auth/ChangePassword';
import Login from './views/auth/Login';
import NotFound from './views/NotFound';
import LoginAsClient from './views/auth/LoginAsClient';
import Licence from './views/Licence';
import Order from './views/Order';
import History from './views/History';
import Messages from './views/Messages';
import RecommendAFriend from './views/RecommendAFriend';
import Contact from './views/Contact';
import ShowOrder from './views/partials/ShowOrder';
import ShowOsOrder from './views/partials/ShowOsOrder';
import { auth } from './middlewares/auth';
import { registeredAccount } from './middlewares/auth';
import NewYear from './views/NewYear';
import OrderSubmitted from './views/partials/order/OrderSubmitted';
import OrderChangeLicence from './views/OrderChangeLicence';
import store from './store/store';
import Promotions from './views/Promotions';
import Course from './views/Course';
import RouterHelper from './helper/routerHelper';
import CourseExam from './views/partials/course-exam/CourseExam';

Vue.use(VueRouter);
let titleSupplement = process.env.MIX_APP_NAME ?? 'Moje Konto';

let routes = [
  {
    path: '/auth/:program/:hash/:staffName?/:id?',
    name: 'LoginAsClient',
    component: LoginAsClient,
    meta: {
      title: 'Logowanie zdalne przez URL',
      gtm: 'Logowanie zdalne przez URL',
    },
  },
  {
    path: '/404',
    name: 'Notfound',
    component: NotFound,
    meta: {
      title: '404 Error',
      gtm: '404 Error',
    },
  },
  {
    path: '/:program',
    component: Home,
    meta: {
      middleware: [auth],
    },
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
        meta: {
          title: 'Logowanie',
        },
      },
      {
        path: 'register',
        name: 'Register',
        component: Register,
        meta: {
          title: 'Rejestracja',
        },
      },
      {
        path: 'password/reset/',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
          title: 'Reset hasła',
        },
      },
      {
        path: 'password/reset/:hash',
        name: 'SetPassword',
        component: SetPassword,
        meta: {
          title: 'Reset hasła URL',
        },
      },
      {
        path: 'moje-konto',
        name: 'Licence',
        component: Licence,
        meta: {
          title: 'Licencja',
          middleware: [auth],
        },
      },
      {
        path: 'zamowienie',
        name: 'Order',
        component: Order,
        meta: {
          title: 'Zamówienie',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'historia-zamowien',
        name: 'History',
        component: History,
        meta: {
          title: 'Historia zamówień',
          middleware: [registeredAccount],
        },
        props: {
          header: true,
          content: true,
        },
      },
      {
        path: 'wiadomosci',
        name: 'Messages',
        component: Messages,
        meta: {
          title: 'Wiadomości',
          middleware: [auth],
        },
      },
      {
        path: 'polec-znajomemu',
        name: 'RecommendAFriend',
        component: RecommendAFriend,
        meta: {
          title: 'Poleć znajomemu',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'kurs-skp',
        name: 'Course',
        component: Course,
        meta: {
          title: 'Kurs SKP - spis treści',
          middleware: [auth],
        },
      },
      {
        path: 'egzamin-kursu',
        name: 'CourseExam',
        component: CourseExam,
        meta: {
          title: 'Egzamin kursu',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'promocje',
        name: 'Promotions',
        component: Promotions,
        meta: {
          title: 'Promocje',
          middleware: [auth],
        },
      },
      {
        path: 'kontakt',
        name: 'Contact',
        component: Contact,
        meta: {
          title: 'Kontakt',
          middleware: [auth],
        },
      },
      {
        path: 'historia-zamowien/:id',
        name: 'ShowOrder',
        component: ShowOrder,
        meta: {
          title: 'Historia zamówień - ID',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'historia-zamowien/aktualizacja/:year/:id',
        name: 'ShowOsOrder',
        component: ShowOsOrder,
        meta: {
          title: 'Historia zamówień - Os',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'co-z-nowym-rokiem',
        name: 'NewYear',
        component: NewYear,
        meta: {
          title: 'Co z nowym rokiem',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'zamowienie-wyslane',
        name: 'OrderSubmitted',
        component: OrderSubmitted,
        meta: {
          title: 'Zamówienie wysłane',
          middleware: [registeredAccount],
        },
      },
      {
        path: 'przeniesienie-licencji',
        name: 'OrderChangeLicence',
        component: OrderChangeLicence,
        meta: {
          title: 'Przeniesienie licencji',
          middleware: [registeredAccount],
        },
      },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    redirect: '/404',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  RouterHelper.withMeta(to, from, next, titleSupplement);
  function isValid(param) {
    return (
      param === 'skp' ||
      param === 'sam' ||
      param === 'skp-test' ||
      param === 'sam-test'
    );
  }
  function isValidQuery(mds) {
    return [
      'X',
      'S',
      'J',
      'A',
      'K',
      'B',
      'C',
      'D',
      'M',
      'P',
      'T',
      'R',
      'F',
      'V',
      'L',
    ].includes(mds);
  }

  if (to.query.mds && isValidQuery(to.query.mds)) {
    store.commit('auth/setOrderQuery', to.query.mds);
  }

  if (to.fullPath !== '/404' && !isValid(to.params.program)) {
    next({ name: 'Notfound' });
  } else {
    if (
      !to.meta.middleware &&
      store.getters['auth/authenticated'] &&
      to.name !== 'LoginAsClient'
    ) {
      return next({
        name: 'Licence',
        params: { program: to.params.program },
      });
    } else if (!to.meta.middleware) {
      return next();
    }
    const middleware = to.meta.middleware;

    return middleware[0]({ to, from, next });
  }
});

export default router;
